// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EpZl","left":"styles_left__1aPoI","right":"styles_right__2R11V","alert":"styles_alert__-pnYd"};